<ph-dialog [open]="open" size="sm" no-close (ph-close)="closed.emit({ startVerification: false })">
    <ph-stack>
        <ph-toolbar inline nowrap align="center" gap="tight">
            <ph-logo></ph-logo>
            <ph-divider orientation="vertical"></ph-divider>
            <ph-hint>secured by</ph-hint>
            <img [src]="stripeWordmark" alt="Stripe" height="20">
        </ph-toolbar>
        <ph-divider></ph-divider>
        <ph-stack gap="tight">
            <ph-auth-heading level="2" size="caption">First, let's verify your association</ph-auth-heading>
            <ph-auth-heading level="p" size="lead">Before a bank account can be connected, federal rules require us to confirm who we're moving money for. Our payments partner Stripe runs this one-time check, called Know Your Customer (KYC) verification.</ph-auth-heading>
        </ph-stack>
        <ph-stack align="start">
            <ph-badge color="blue" variant="lighter"><ph-icon name="clock" size="sm"></ph-icon>Takes about 3 minutes</ph-badge>
        </ph-stack>
        <ph-card flat>
            <ph-stack gap="snug">
                <ph-label>Have ready</ph-label>
                <ph-toolbar inline nowrap align="center" gap="tight" class="have-ready-item">
                    <span class="have-ready-icon" aria-hidden="true"><i class="ph ph-suitcase-simple icon-muted icon-16"></i></span>
                    <span>Your HOA's legal name, address, and EIN</span>
                </ph-toolbar>
                <ph-toolbar inline nowrap align="center" gap="tight" class="have-ready-item">
                    <span class="have-ready-icon" aria-hidden="true"><i class="ph ph-user-list icon-muted icon-16"></i></span>
                    <span>Contact information for the authorized representative</span>
                </ph-toolbar>
                <ph-toolbar inline nowrap align="center" gap="tight" class="have-ready-item">
                    <span class="have-ready-icon" aria-hidden="true"><i class="ph ph-identification-card icon-muted icon-16"></i></span>
                    <span>A photo ID for the authorized representative</span>
                </ph-toolbar>
            </ph-stack>
        </ph-card>
        <ph-auth-note tone="neutral">
            <ph-toolbar inline nowrap align="start" gap="tight" class="secure-form-note">
                <ph-icon name="lock-key" size="sm"></ph-icon>
                <span>You'll enter this on Stripe's secure form. It's encrypted in transit, and PayHOA never sees or stores your ID, SSN, or bank credentials.</span>
            </ph-toolbar>
        </ph-auth-note>
        <ph-hint><span [innerHTML]="disclosureText"></span></ph-hint>
    </ph-stack>
    <ph-actions slot="footer" align="between">
        <ph-button variant="secondary" mode="stroke" (click)="closed.emit({ startVerification: false })">Cancel</ph-button>
        <ph-button trailing-icon="arrow-right" (click)="closed.emit({ startVerification: true })">Start verification</ph-button>
    </ph-actions>
</ph-dialog>
